export const categories = [
  {
    id: 'business-solutions',
    name: '企业解决方案',
    icon: 'ri-building-2-line',
    description: '为各类企业提供端到端的数字化解决方案，覆盖企业管理、流程优化、数据分析等核心业务领域。btbxx企业解决方案帮助您实现业务数字化转型。',
    features: [
      { name: '智能办公系统', desc: '集成化办公平台，提升团队协作效率300%' },
      { name: '数据分析引擎', desc: '实时数据洞察，驱动精准业务决策' },
      { name: '流程自动化', desc: '自动化审批流程，减少人工操作80%' },
      { name: '项目管理工具', desc: '全生命周期项目管理，确保按时交付' },
    ],
  },
  {
    id: 'tech-platform',
    name: '技术平台',
    icon: 'ri-cloud-line',
    description: '基于云原生架构的技术平台，提供高可用、高扩展性的技术基础设施。btbxx技术平台支撑海量业务并发处理，保障系统稳定运行。',
    features: [
      { name: '云原生架构', desc: '容器化部署，弹性伸缩，按需付费' },
      { name: 'API集成中心', desc: '标准化API接口，快速对接第三方系统' },
      { name: '安全防护体系', desc: '多层安全防护，数据加密传输存储' },
      { name: '智能监控告警', desc: '7x24小时系统监控，异常秒级响应' },
    ],
  },
  {
    id: 'marketing-growth',
    name: '营销增长',
    icon: 'ri-line-chart-line',
    description: '全渠道数字营销解决方案，助力企业实现用户增长和品牌传播。btbxx营销增长服务覆盖社交、搜索、内容等多个触达渠道。',
    features: [
      { name: '智能投放系统', desc: 'AI驱动广告投放，ROI提升200%' },
      { name: '内容营销矩阵', desc: '多平台内容分发，品牌声量持续增长' },
      { name: '用户画像分析', desc: '精准用户分层，个性化触达策略' },
      { name: '转化漏斗优化', desc: '全链路转化分析，降低获客成本' },
    ],
  },
  {
    id: 'customer-service',
    name: '客户服务',
    icon: 'ri-customer-service-2-line',
    description: '以客户为中心的智能服务体系，涵盖售前咨询、售后支持、客户关系管理等全方位服务。btbxx客户服务让每一位客户都获得极致体验。',
    features: [
      { name: '智能客服机器人', desc: '7x24小时在线应答，解决率超90%' },
      { name: '工单管理系统', desc: '高效工单流转，问题闭环处理' },
      { name: '客户反馈分析', desc: 'NLP情感分析，洞察客户真实需求' },
      { name: '服务质量管理', desc: '全流程服务监控，满意度可视化' },
    ],
  },
  {
    id: 'data-intelligence',
    name: '数据智能',
    icon: 'ri-brain-line',
    description: '大数据与人工智能深度融合的智能分析平台，为企业提供从数据采集到智能决策的全链路服务。btbxx数据智能让数据真正驱动业务增长。',
    features: [
      { name: '数据可视化看板', desc: '拖拽式图表配置，数据一目了然' },
      { name: 'AI预测模型', desc: '机器学习预测，提前把握市场趋势' },
      { name: '用户行为分析', desc: '全量行为轨迹追踪，优化产品体验' },
      { name: '报表自动生成', desc: '定制化报表，一键导出分享' },
    ],
  },
  {
    id: 'ecommerce',
    name: '电商服务',
    icon: 'ri-shopping-cart-2-line',
    description: '一站式电商解决方案，从店铺搭建、商品管理到订单处理、物流配送全覆盖。btbxx电商服务助力商家快速搭建线上销售渠道。',
    features: [
      { name: '多店铺管理', desc: '统一后台管理多平台店铺' },
      { name: '智能库存管理', desc: 'AI库存预测，降低缺货率' },
      { name: '订单自动化处理', desc: '自动分单、打单、发货通知' },
      { name: '售后服务体系', desc: '标准化退换货流程，提升客户满意度' },
    ],
  },
];